import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { ClassTags, CreateClassTypesRequest } from '@fitness-force/models';

import { environment } from '@fitness-force/environments';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';


@Injectable({
  providedIn: 'root'
})
export class ClassTypeService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };



  createClassTypes(
    tenantId: number,
    createAppointmentTypesRequest: CreateClassTypesRequest
  ) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.CREATE_CLASS_TYPE
          .replace('{tenant_id}', tenantId.toString()),
        createAppointmentTypesRequest,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateClassTypes(tenantId: number,class_type_id:number,data:any) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.UPDATE_CLASS_TYPE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{class_type_id}', class_type_id.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClassTypes(tenantId: number,allParams:Array<string>=[]) {

    let parsedParams = new HttpParams()
   if(allParams.length > 0){

    allParams.forEach((p: any) => {

      parsedParams = parsedParams.append(p.name, p.value);
    });
   }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.GET_CLASS_TYPES
          .replace('{tenant_id}', tenantId.toString()),
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markActive(tenantId: number,class_type_id:number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.MARK_CLASS_TYPE_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{class_type_id}', class_type_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number,class_type_id:number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.MARK_CLASS_TYPE_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{class_type_id}', class_type_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



  getSingleClassType(tenantId: number,class_type_id:number) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.GET_CLASS_TYPE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{class_type_id}', class_type_id.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  getClassTags(tenantId: number):Observable<ClassTags[]> {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CLASS_TYPE.GET_CLASS_TAGS
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res.items;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCompanyLevelClassTypes():Observable<any[]> {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_CLASS_TYPES,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res.items;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
